import { createAction } from 'redux-actions';

const actions = {
  /**
   *  추천 상품 후기 데이터 변경하기
   */
  SET_DATA: 'recommend/review/SET_DATA',
  setData: createAction('recommend/review/SET_DATA'),

  /**
   *  추천 상품 후기 리스트 가져오기
   */
  GET_RECOMMEND_REVIEW_LIST_REQUEST: 'recommend/review/GET_RECOMMEND_REVIEW_LIST_REQUEST',
  GET_RECOMMEND_REVIEW_LIST_SUCCESS: 'recommend/review/GET_RECOMMEND_REVIEW_LIST_SUCCESS',
  getRecommendReviewList: createAction('recommend/review/GET_RECOMMEND_REVIEW_LIST_REQUEST'),

  /**
   *  추천 상품 후기 상세 요청하기
   */
  GET_RECOMMEND_REVIEW_DETAIL_REQUEST: 'recommend/review/GET_RECOMMEND_REVIEW_DETAIL_REQUEST',
  GET_RECOMMEND_REVIEW_DETAIL_SUCCESS: 'recommend/review/GET_RECOMMEND_REVIEW_DETAIL_SUCCESS',
  getRecommendReviewDetail: createAction('recommend/review/GET_RECOMMEND_REVIEW_DETAIL_REQUEST'),

  /**
   *  추천 상품 후기 복사하기 전 필요한 데이터 가져오기
   */
  PREPARE_COPY_RECOMMEND_REVIEW_REQUEST: 'recommend/review/PREPARE_COPY_RECOMMEND_REVIEW_REQUEST',
  PREPARE_COPY_RECOMMEND_REVIEW_SUCCESS: 'recommend/review/PREPARE_COPY_RECOMMEND_REVIEW_SUCCESS',
  prepareCopyRecommendReview: createAction('recommend/review/PREPARE_COPY_RECOMMEND_REVIEW_REQUEST'),

  /**
   *  추천 상품 후기 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_CREATE_RECOMMEND_REVIEW_REQUEST: 'recommend/review/PREPARE_CREATE_RECOMMEND_REVIEW_REQUEST',
  PREPARE_CREATE_RECOMMEND_REVIEW_SUCCESS: 'recommend/review/PREPARE_CREATE_RECOMMEND_REVIEW_SUCCESS',
  prepareCreateRecommendReview: createAction('recommend/review/PREPARE_CREATE_RECOMMEND_REVIEW_REQUEST'),

  /**
   *  추천 상품 후기에 연결할 아이템 리스트 요청하기
   */
  GET_RECOMMEND_REVIEW_ITEM_REQUEST: 'recommend/review/GET_RECOMMEND_REVIEW_ITEM_REQUEST',
  GET_RECOMMEND_REVIEW_ITEM_SUCCESS: 'recommend/review/GET_RECOMMEND_REVIEW_ITEM_SUCCESS',
  getRecommendReviewItemList: createAction('recommend/review/GET_RECOMMEND_REVIEW_ITEM_REQUEST'),

  /**
   *  추천 상품 후기 등록/복사하기
   */
  CREATE_RECOMMEND_REVIEW_REQUEST: 'recommend/review/CREATE_RECOMMEND_REVIEW_REQUEST',
  createRecommendReview: createAction('recommend/review/CREATE_RECOMMEND_REVIEW_REQUEST'),

  /**
   *  전체 상품 후기 리스트 EXCEL 다운로드
   */
  GET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/review/GET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getRecommendReviewItemListExcelDownload: createAction(
    'recommend/review/GET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  선택된 상품 후기 리스트 EXCEL 다운로드
   */
  GET_SELECTED_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/review/GET_SELECTED_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedRecommendReviewItemListExcelDownload: createAction(
    'recommend/review/GET_SELECTED_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  상품 후기 리스트 EXCEL 업로드
   */
  SET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_UPLOAD_REQUEST:
    'recommend/review/SET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  SET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_UPLOAD_SUCCESS:
    'recommend/review/SET_RECOMMEND_REVIEW_ITEM_EXCEL_UPLOAD_SUCCESS',
  setRecommendReviewItemListExcelUpload: createAction(
    'recommend/review/SET_RECOMMEND_REVIEW_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  ),
};

export default actions;
